import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ITooltipComponent} from "@shared/models/common.models";

@Component({
    standalone: false,
    selector: 'particle-filing-mandatory-field-error-tooltip',
  templateUrl: './filing-mandatory-field-error-tooltip.component.html',
  styleUrls: ['./filing-mandatory-field-error-tooltip.component.scss']
})
export class FilingMandatoryFieldErrorTooltipComponent implements OnInit, ITooltipComponent{
  inputMetadata: any;
  @Output() action = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    //this.action.emit('hola');
  }

}
